var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42769 1.4284C6.03355 1.4284 5.71363 1.74793 5.71363 2.14285C5.71363 2.53777 6.03355 2.85691 6.42769 2.85691H6.7855C7.76988 2.85691 8.5714 3.65769 8.5714 4.64281V5.35687C8.5714 6.34203 7.76984 7.14277 6.7855 7.14277H6.42769C6.03355 7.14277 5.71363 7.46191 5.71363 7.85683C5.71363 8.25175 6.03355 8.57128 6.42769 8.57128H6.7855C8.5578 8.57128 10 7.12908 10 5.35678V4.64272C10 2.87042 8.5578 1.42822 6.7855 1.42822L6.42769 1.4284ZM3.21399 1.4284C1.44169 1.4284 -0.000505447 2.8706 -0.000505447 4.6429V5.35696C-0.000505447 7.12926 1.44169 8.57146 3.21399 8.57146H3.57024C3.96516 8.57146 4.28469 8.25193 4.28469 7.85701C4.28469 7.46209 3.96516 7.14295 3.57024 7.14295H3.21399C2.22961 7.14295 1.42809 6.34217 1.42809 5.35705V4.64299C1.42809 3.65783 2.22965 2.85709 3.21399 2.85709H3.57024C3.96516 2.85709 4.28469 2.53795 4.28469 2.14303C4.28469 1.74811 3.96516 1.42858 3.57024 1.42858L3.21399 1.4284ZM3.57102 4.2854C3.17805 4.2854 2.85657 4.60688 2.85657 4.99985C2.85657 5.39282 3.17805 5.7143 3.57102 5.7143H6.42802C6.82099 5.7143 7.14247 5.39282 7.14247 4.99985C7.14247 4.60688 6.82099 4.2854 6.42802 4.2854H3.57102Z",
    fill: "#B0B0B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "matrix(-1 0 0 1 10 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.3d42b6cd.svg";
export { ForwardRef as ReactComponent };